<form class="set-password-form" [formGroup]="form" autocomplete="off">
  <div class="mb20">
    <app-password
      [label]="'general.password_l'"
      [showRequiredBox]="true"
      [placeholder]="'forms.password_placeholder' | translate"
      formControlName="password"
    >
    </app-password>
  </div>
  <div class="mb20">
    <app-password
      [label]="'general.confirm_password_l'"
      [placeholder]="'forms.confirm_password_placeholder' | translate"
      formControlName="confirmedPassword"
    >
    </app-password>
  </div>
  <button
    im-button
    class="primary"
    [disabled]="!form?.valid || isSaving()"
    (click)="setPassword()"
  >
    {{ ctaButtonLabel() || 'general.save_a' | translate }}
  </button>
</form>
